<script>
import AbstractWysiwygInput from "@/components/General/Form/Wysiwyg/Abstract/AbstractWysiwygInput";

export default {
    extends: AbstractWysiwygInput,
}
</script>
